/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CarrierInfoResponse,
  CarrierLoginUrlResponse,
  CarrierPortalActivity,
  CarrierProperties,
  CarrierPropertiesHistory,
  CarrierPropertiesInput,
  CarrierServiceInfo,
  CarrierWithFSCLevels,
  ServiceProperties,
  UpcomingAmyShipmentTasks,
} from "../models/index";
import {
  CarrierInfoResponseFromJSON,
  CarrierInfoResponseToJSON,
  CarrierLoginUrlResponseFromJSON,
  CarrierLoginUrlResponseToJSON,
  CarrierPortalActivityFromJSON,
  CarrierPortalActivityToJSON,
  CarrierPropertiesFromJSON,
  CarrierPropertiesToJSON,
  CarrierPropertiesHistoryFromJSON,
  CarrierPropertiesHistoryToJSON,
  CarrierPropertiesInputFromJSON,
  CarrierPropertiesInputToJSON,
  CarrierServiceInfoFromJSON,
  CarrierServiceInfoToJSON,
  CarrierWithFSCLevelsFromJSON,
  CarrierWithFSCLevelsToJSON,
  ServicePropertiesFromJSON,
  ServicePropertiesToJSON,
  UpcomingAmyShipmentTasksFromJSON,
  UpcomingAmyShipmentTasksToJSON,
} from "../models/index";

export interface EditCarrierPropertiesRequest {
  carrierPropertiesInput: CarrierPropertiesInput;
}

export interface GenerateCarrierLoginUrlRequest {
  carrierIdentifier: string;
  tab?: string | null;
}

export interface GetCarrierInfoRequest {
  carrierIdentifier: string;
  serviceIdentifier?: string | null;
}

export interface GetCarrierPortalActivityRequest {
  carrierIdentifier: string;
}

export interface GetCarrierPropertiesRequest {
  carrierIdentifier: string;
}

export interface GetHistoryRecordsForCarrierPropertiesRequest {
  carrierPropertiesId: string;
}

export interface GetServiceInfoRequest {
  carrierIdentifier: string;
  serviceIdentifier: string;
}

export interface InsertCarrierPropertyRequest {
  carrierPropertiesInput: CarrierPropertiesInput;
}

export interface RotateCarrierLoginLinksRequest {
  carrierIdentifier: string;
}

/**
 *
 */
export class CarriersApi extends runtime.BaseAPI {
  /**
   */
  async editCarrierPropertiesRaw(
    requestParameters: EditCarrierPropertiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierPropertiesInput"] == null) {
      throw new runtime.RequiredError(
        "carrierPropertiesInput",
        'Required parameter "carrierPropertiesInput" was null or undefined when calling editCarrierProperties().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carriers/edit-carrier-properties`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierPropertiesInputToJSON(
          requestParameters["carrierPropertiesInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editCarrierProperties(
    requestParameters: EditCarrierPropertiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editCarrierPropertiesRaw(requestParameters, initOverrides);
  }

  /**
   * Mint a carrier portal login link for the operations team to send to a carrier. The link carries a permanent signed token (no expiry) scoped to this one carrier; opening it logs the carrier in. The token is signed by \\[CarrierPortalTokenService\\] and verified by the carrier portal backend. An optional \\[tab\\] deep-links the carrier to a specific top-level portal section (e.g. \"operational-issues\"); the portal reads it from the \\`view\\` query param. (\\`view\\` is the top-level nav; \\`tab\\` is reserved for in-page tab strips like the Performance sections.) Omit it to land on the default section.
   * Mint a carrier portal login link for the operations team to send to a carrier.
   */
  async generateCarrierLoginUrlRaw(
    requestParameters: GenerateCarrierLoginUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierLoginUrlResponse>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling generateCarrierLoginUrl().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    if (requestParameters["tab"] != null) {
      queryParameters["tab"] = requestParameters["tab"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/generate-login-url`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierLoginUrlResponseFromJSON(jsonValue),
    );
  }

  /**
   * Mint a carrier portal login link for the operations team to send to a carrier. The link carries a permanent signed token (no expiry) scoped to this one carrier; opening it logs the carrier in. The token is signed by \\[CarrierPortalTokenService\\] and verified by the carrier portal backend. An optional \\[tab\\] deep-links the carrier to a specific top-level portal section (e.g. \"operational-issues\"); the portal reads it from the \\`view\\` query param. (\\`view\\` is the top-level nav; \\`tab\\` is reserved for in-page tab strips like the Performance sections.) Omit it to land on the default section.
   * Mint a carrier portal login link for the operations team to send to a carrier.
   */
  async generateCarrierLoginUrl(
    requestParameters: GenerateCarrierLoginUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierLoginUrlResponse> {
    const response = await this.generateCarrierLoginUrlRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCarrierInfoRaw(
    requestParameters: GetCarrierInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierInfoResponse>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling getCarrierInfo().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    if (requestParameters["serviceIdentifier"] != null) {
      queryParameters["serviceIdentifier"] =
        requestParameters["serviceIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/get-carrier-info`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierInfoResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getCarrierInfo(
    requestParameters: GetCarrierInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierInfoResponse> {
    const response = await this.getCarrierInfoRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Who at this carrier has used the portal, and what they opened. The portal\'s credential is a permanent link shared around a carrier\'s team with a self-asserted name, so this table is the only durable record of who has been in. Worth having in front of whoever is deciding whether to rotate a carrier\'s links, or wondering whether a section is used at all. Self-asserted identity stays self-asserted: this shows what somebody typed.
   * Who at this carrier has used the portal, and what they opened.
   */
  async getCarrierPortalActivityRaw(
    requestParameters: GetCarrierPortalActivityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierPortalActivity>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling getCarrierPortalActivity().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/portal-activity`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierPortalActivityFromJSON),
    );
  }

  /**
   * Who at this carrier has used the portal, and what they opened. The portal\'s credential is a permanent link shared around a carrier\'s team with a self-asserted name, so this table is the only durable record of who has been in. Worth having in front of whoever is deciding whether to rotate a carrier\'s links, or wondering whether a section is used at all. Self-asserted identity stays self-asserted: this shows what somebody typed.
   * Who at this carrier has used the portal, and what they opened.
   */
  async getCarrierPortalActivity(
    requestParameters: GetCarrierPortalActivityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierPortalActivity>> {
    const response = await this.getCarrierPortalActivityRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCarrierPropertiesRaw(
    requestParameters: GetCarrierPropertiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierProperties>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling getCarrierProperties().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/get-carrier-properties`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierPropertiesFromJSON(jsonValue),
    );
  }

  /**
   */
  async getCarrierProperties(
    requestParameters: GetCarrierPropertiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierProperties> {
    const response = await this.getCarrierPropertiesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCarrierServicesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierServiceInfo>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/get-carrier-services`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierServiceInfoFromJSON),
    );
  }

  /**
   */
  async getCarrierServices(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierServiceInfo>> {
    const response = await this.getCarrierServicesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getCarriersWithFSCLevelsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierWithFSCLevels>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/get-carriers-fsc-levels`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierWithFSCLevelsFromJSON),
    );
  }

  /**
   */
  async getCarriersWithFSCLevels(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierWithFSCLevels>> {
    const response = await this.getCarriersWithFSCLevelsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getHistoryRecordsForCarrierPropertiesRaw(
    requestParameters: GetHistoryRecordsForCarrierPropertiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierPropertiesHistory>>> {
    if (requestParameters["carrierPropertiesId"] == null) {
      throw new runtime.RequiredError(
        "carrierPropertiesId",
        'Required parameter "carrierPropertiesId" was null or undefined when calling getHistoryRecordsForCarrierProperties().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierPropertiesId"] != null) {
      queryParameters["carrierPropertiesId"] =
        requestParameters["carrierPropertiesId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/history-for-carrier-properties`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierPropertiesHistoryFromJSON),
    );
  }

  /**
   */
  async getHistoryRecordsForCarrierProperties(
    requestParameters: GetHistoryRecordsForCarrierPropertiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierPropertiesHistory>> {
    const response = await this.getHistoryRecordsForCarrierPropertiesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getServiceInfoRaw(
    requestParameters: GetServiceInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ServiceProperties>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling getServiceInfo().',
      );
    }

    if (requestParameters["serviceIdentifier"] == null) {
      throw new runtime.RequiredError(
        "serviceIdentifier",
        'Required parameter "serviceIdentifier" was null or undefined when calling getServiceInfo().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    if (requestParameters["serviceIdentifier"] != null) {
      queryParameters["serviceIdentifier"] =
        requestParameters["serviceIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/get-service-info`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ServicePropertiesFromJSON(jsonValue),
    );
  }

  /**
   */
  async getServiceInfo(
    requestParameters: GetServiceInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ServiceProperties> {
    const response = await this.getServiceInfoRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async insertCarrierPropertyRaw(
    requestParameters: InsertCarrierPropertyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierPropertiesInput"] == null) {
      throw new runtime.RequiredError(
        "carrierPropertiesInput",
        'Required parameter "carrierPropertiesInput" was null or undefined when calling insertCarrierProperty().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carriers/insert-carrier-properties`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierPropertiesInputToJSON(
          requestParameters["carrierPropertiesInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async insertCarrierProperty(
    requestParameters: InsertCarrierPropertyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.insertCarrierPropertyRaw(requestParameters, initOverrides);
  }

  /**
   * Revoke a carrier\'s login links and live sessions. The portal credential is a permanent link that gets forwarded around, so until now a link that reached the wrong inbox worked forever --- the only lever was the global signing key, which would have signed out every carrier at once. Rotating replaces this carrier\'s own signing secret. Their existing links stop working immediately, as do sessions already opened from them, and no other carrier is affected. Ops generates a fresh link afterwards and sends it.
   * Revoke a carrier\'s login links and live sessions.
   */
  async rotateCarrierLoginLinksRaw(
    requestParameters: RotateCarrierLoginLinksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierLoginUrlResponse>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling rotateCarrierLoginLinks().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/rotate-login-links`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierLoginUrlResponseFromJSON(jsonValue),
    );
  }

  /**
   * Revoke a carrier\'s login links and live sessions. The portal credential is a permanent link that gets forwarded around, so until now a link that reached the wrong inbox worked forever --- the only lever was the global signing key, which would have signed out every carrier at once. Rotating replaces this carrier\'s own signing secret. Their existing links stop working immediately, as do sessions already opened from them, and no other carrier is affected. Ops generates a fresh link afterwards and sends it.
   * Revoke a carrier\'s login links and live sessions.
   */
  async rotateCarrierLoginLinks(
    requestParameters: RotateCarrierLoginLinksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierLoginUrlResponse> {
    const response = await this.rotateCarrierLoginLinksRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async summarizeExpectedAmyTasksRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UpcomingAmyShipmentTasks>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carriers/summarize-expected-amy-tasks`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UpcomingAmyShipmentTasksFromJSON(jsonValue),
    );
  }

  /**
   */
  async summarizeExpectedAmyTasks(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<UpcomingAmyShipmentTasks> {
    const response = await this.summarizeExpectedAmyTasksRaw(initOverrides);
    return await response.value();
  }
}
